import Image from 'next/image';
import { memo } from 'react';

import src from './three-birds-flying-video.png';

export const ThreeBirdsFlyingVideo = memo(() => (
  <Image alt="Drop here to upload" className="block size-40" height={160} src={src} width={160} />
));

ThreeBirdsFlyingVideo.displayName = 'ThreeBirdsFlyingVideo';
